<template>
  <div class="row">
    <div class="col-md-8">
      <Panel>
        <template slot="header">
          <h4>{{ result.key.round }} Results</h4>
        </template>

        <Table class="Overview" slot="body">
          <Row header>
            <Cell>Placement</Cell>

            <!-- <Cell v-if="game.isRated === true">Placement</Cell> -->

            <Cell class="text-left">Player</Cell>
            <Cell>Mode</Cell>
            <Cell v-tooltip="'The team rating is the average rating of all players on the team.'">Rating</Cell>
            <Cell>Rating Change</Cell>
          </Row>

          <template v-for="team in result.teams">
            <Row
              v-for="(player, index) in team.players"
              :class="{
                'Table-boundary' : index === 0,
                'Table-noborder' : index !== 0
              }"
              class="clickable"
              :style="`background-color: ${player.isLeaver || player.isDrawn ? 'transparent' : placementBackground (team.placement)}`"
              @click.native="
                if (selectedPlayer.name !== player.name) {
                  profileDirectory = null;
                  selectedPlayer = player
                }
              "
            >
              <Cell>
                {{ player.placement > 0 ? ordinal (player.placement) : 'Draw' }}
              </Cell>

              <Cell class="text-left">
                <span
                  :style="'color: ' + rgba ('--wc3-' + lang (`colour.${player.colour}`))"
                >
                  {{ battleTag (player.name) }}
                </span>
              </Cell>

              <Cell>{{ player.key.mode }}</Cell>

              <Cell>
                {{ player.rating }}

                <Bar :fill="relative ('rating', player, result.getPlayers ())"
                      width="80px">
                </Bar>
              </Cell>

              <Cell>
                <Delta
                  :x="player.change"
                  :showNumber="true"
                ></Delta>
              </Cell>
            </Row>
          </template>
        </Table>
      </Panel>
    </div>

    <div class="col-md-4">
      <Loader
        :url="`/profiles/${urlencode (selectedPlayer.name)}`"
        v-model="profileDirectory"
      >
        <Loader
          slot="result"
          v-if="profileDirectory"
          v-model="profile"
          :url="getProfileUrl ()"
          :model="Profile"
          :hidden="true"
        >
          <Panel
            slot="result"
            v-if="profile"
          >
            <template slot="header">
              <h4>
                Stats for {{ profile.name }}

                <router-link
                  :to="decodeURI (
                    resolve ({
                      name: 'playerProfile',
                      params: {
                        name: profile.name
                      }
                    })
                  )"
                  v-tooltip="'Full Profile'"
                  class="ml10"
                >
                  <i class="fas fa-external-link-alt"></i>
                </router-link>
              </h4>
            </template>

            <template slot="body">
              <Basic
                :profile="profile"
              >
              </Basic>
            </template>
          </Panel>
        </Loader>
      </Loader>
    </div>
  </div>
</template>

<script>
  import { Table, Row, Cell } from '@/legacy/components/widgets/Table.js';
  import Bar from '@/legacy/components/widgets/Bar';
  import Block from '@/legacy/components/widgets/Block';
  import Delta from '@/legacy/components/widgets/Delta';
  import Loader from '@/legacy/components/widgets/Loader';
  import Panel from '@/legacy/components/widgets/Panel';
  import Result from '@/legacy/lib//model/Result';
  import Basic from '@/legacy/views/player/Basic';
  import Profile from '@/legacy/lib//model/Profile';
  import { relative, ordinal, interpolateColour, filterByKey, urlencode } from '@/legacy/lib//util';
  import { rgba, colourId, battleTag } from '@/legacy/lib//template';
  import { lang } from '@/legacy/lib//lang';
  import { resolve } from '@/legacy/lib/routerUtils';

  export default {
    props: {
      result: {
        type: Result
      }
    },

    data () {
      return {
        selectedPlayer: this
          .result
          .getPlayers () [0],

        profileDirectory: null,
        profile: null,
      }
    },

    components: {
      Table,
      Row,
      Cell,
      Bar,
      Delta,
      Basic,
      Panel,
      Loader
    },

    methods: {
      rgba,
      relative,
      ordinal,
      resolve,
      lang,
      urlencode,
      battleTag,
      Profile,

      getProfileUrl () {
        let k, p;

        k = this.result.key;
        k.mode = this.selectedPlayer.key.mode;

        p = filterByKey (
          this.profileDirectory,
          k
        ) [0];

        return `/profiles/${urlencode (this.selectedPlayer.name)}/${p.id}`;
      },

      placementBackground (placement) {
        return interpolateColour (
          (placement - 1) / (this.result.max ('placement') - 1) * 100,
          null,
          null,
          true,
          0.06
        )
      }
    }
  };
</script>